import { useEffect, useState } from 'react';
import { apiPublic } from './api';
import { ARTISTS as SEED_ARTISTS, DAYS as SEED_DAYS } from '../data/artists';
import { PROGRAM as SEED_PROGRAM } from '../data/program';
import { PARTNERS as SEED_PARTNERS } from '../data/partners';

/**
 * Fetch public CMS data with seed-fallback if API fails.
 * Hooks return { data, loading, error }. They never throw.
 */
export const useFestivalDays = () => {
    const [state, setState] = useState({ data: SEED_PROGRAM, loading: true, error: null });
    useEffect(() => {
        let mounted = true;
        apiPublic.get('/festival-days')
            .then((r) => mounted && setState({ data: r.data || SEED_PROGRAM, loading: false, error: null }))
            .catch((e) => mounted && setState({ data: SEED_PROGRAM, loading: false, error: e }));
        return () => { mounted = false; };
    }, []);
    return state;
};

export const useArtists = () => {
    const [state, setState] = useState({ data: SEED_ARTISTS, loading: true, error: null });
    useEffect(() => {
        let mounted = true;
        apiPublic.get('/artists')
            .then((r) => mounted && setState({ data: r.data || SEED_ARTISTS, loading: false, error: null }))
            .catch((e) => mounted && setState({ data: SEED_ARTISTS, loading: false, error: e }));
        return () => { mounted = false; };
    }, []);
    return state;
};

export const usePartners = () => {
    const [state, setState] = useState({ data: SEED_PARTNERS, loading: true, error: null });
    useEffect(() => {
        let mounted = true;
        apiPublic.get('/partners')
            .then((r) => mounted && setState({ data: r.data || SEED_PARTNERS, loading: false, error: null }))
            .catch((e) => mounted && setState({ data: SEED_PARTNERS, loading: false, error: e }));
        return () => { mounted = false; };
    }, []);
    return state;
};

export const useFamilyActivities = () => {
    const [state, setState] = useState({ data: [], loading: true, error: null });
    useEffect(() => {
        let mounted = true;
        apiPublic.get('/family-activities')
            .then((r) => mounted && setState({ data: r.data || [], loading: false, error: null }))
            .catch((e) => mounted && setState({ data: [], loading: false, error: e }));
        return () => { mounted = false; };
    }, []);
    return state;
};

export const useParkings = () => {
    const [state, setState] = useState({ data: [], loading: true, error: null });
    useEffect(() => {
        let mounted = true;
        apiPublic.get('/parkings')
            .then((r) => mounted && setState({ data: r.data || [], loading: false, error: null }))
            .catch((e) => mounted && setState({ data: [], loading: false, error: e }));
        return () => { mounted = false; };
    }, []);
    return state;
};

export const useSettings = () => {
    const [state, setState] = useState({ data: null, loading: true, error: null });
    useEffect(() => {
        let mounted = true;
        apiPublic.get('/settings/public')
            .then((r) => mounted && setState({ data: r.data, loading: false, error: null }))
            .catch((e) => mounted && setState({ data: null, loading: false, error: e }));
        return () => { mounted = false; };
    }, []);
    return state;
};

export const useZomerkickAvailability = () => {
    const [state, setState] = useState({ data: { used: 0, max: 3, available: 3 }, loading: true });
    useEffect(() => {
        let mounted = true;
        apiPublic.get('/zomerkick-availability')
            .then((r) => mounted && setState({ data: r.data, loading: false }))
            .catch(() => mounted && setState({ data: { used: 0, max: 3, available: 3 }, loading: false }));
        return () => { mounted = false; };
    }, []);
    return state;
};

// Re-export day metadata for filter labels
export const DAYS_META = SEED_DAYS;
